import { reducerWithInitialState } from "typescript-fsa-reducers";

import { bootstrapCompanyAbout, loadCompanyAbout } from "../actions";

export interface AboutState {
  isLoaded: boolean;
}

const InitialState: AboutState = {
  isLoaded: false,
};

const aboutReducer = reducerWithInitialState<AboutState>(InitialState)
  .case(bootstrapCompanyAbout, state => {
    return {
      ...state,
      isLoaded: true,
    };
  })
  .case(loadCompanyAbout.done, state => {
    return {
      ...state,
      isLoaded: true,
    };
  });

export default aboutReducer;



// WEBPACK FOOTER //
// ./frontend/src/companies/reducers/about.ts